import { render, staticRenderFns } from "./BaseAppLineAvatar.vue?vue&type=template&id=1315f357&scoped=true"
import script from "./BaseAppLineAvatar.vue?vue&type=script&lang=js"
export * from "./BaseAppLineAvatar.vue?vue&type=script&lang=js"
import style0 from "./BaseAppLineAvatar.vue?vue&type=style&index=0&id=1315f357&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1315f357",
  null
  
)

export default component.exports